export const CALCULATION_TYPES = ['WORSTOF', 'BESTOFPUT'] as const

export type CalculationType = (typeof CALCULATION_TYPES)[number]

export const CALCULATION_TYPE_OPTIONS = CALCULATION_TYPES.map((o) => ({
  label: o,
  value: o,
}))
